import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { mr } from 'styled-components-spacing/dist/cjs'

const Icon = styled(FontAwesomeIcon)`
  color: white;
  font-size: 20px;
  ${mr(3)};
`

export default Icon
